import { useMemo } from "react";
import { useAppSelector } from "../../store/hooks/hooks";
import type { IMaterialBalanceResultRow } from "../../interfaces/interfaces";

const ResultTable = () => {
	const results = useAppSelector(state => state.materialBalance.resultTable);
	const inputs = useAppSelector(state => state.materialBalance.inputTable);
	const rows = useMemo(() => {
		// if (results && Object.keys(results).length > 0) {
		// 	return results;
		// }

		if (!inputs)
			return {};

		const resultRows: Record<number, IMaterialBalanceResultRow> = {};
		Object.keys(inputs).forEach(key => {
			resultRows[Number(key)] = {
				g: results ? results[Number(key)]?.g ?? 0 : 0,
				z: results ? results[Number(key)]?.z ?? 0 : 0,
				pz: results ? results[Number(key)]?.pz ?? 0 : 0,
			};
		});
		return resultRows;

	}, [results, inputs]);

	return (
		<div className="material-balance__result-table round-corner-container">
			<div className="material-balance__result-head">
				<div className="material-balance__result-cell">Gp</div>
				<div className="material-balance__result-cell">z</div>
				<div className="material-balance__result-cell">P/z</div>
			</div>
			<div className="material-balance__result-units">
				<div className="material-balance__result-cell">млн м3</div>
				<div className="material-balance__result-cell"></div>
				<div className="material-balance__result-cell"></div>
			</div>
			{Object.entries(rows).map(([key, row]) => (
				<div key={key} className="material-balance__result-row">
					{Object.entries(row).map(([subKey, value]) => (
						<div key={subKey} className="material-balance__result-cell">
							{value}
						</div>
					))}
				</div>
			))}
		</div>
	);
};

export default ResultTable;